import { createSelector } from 'reselect';
import { getLoggedUser } from 'Selectors/user';
import { urls } from 'Reducers/items';
import { decodeFilters, transformAdsFilterParams } from 'Helpers/filters';
import { paramsToQueryString } from 'Helpers/url';
import { getType } from 'Reducers/helpers/typeModifier';

export const getOpenRemoveAfterMarkAsSold = state => {
    return state.myads.openRemoveAfterMarkAsSold;
};

const getUrl = (state, props) => {
    const user = getLoggedUser(state);
    let params = null;

    if (!user) {
        return null;
    }

    const lang = state.api && state.api.queryParam && state.api.queryParam.enableMultiLang && state.api.queryParam.lang;
    let urlWithParams = urls.getUserAds(user.id);

    if (props.filter) {
        const decodedFilters = decodeFilters(props.filter);

        params = params || {};
        params = { ...params, ...transformAdsFilterParams(decodedFilters) };
    }

    if (lang) {
        params = params || {};
        params.lang = lang;
    }

    if (params) {
        urlWithParams += `?${paramsToQueryString(params)}`;
    }

    const type = getType('ITEMS', urlWithParams);

    return type;
};

const getCollection = (state, props) => {
    const { currentPage = 1 } = props;
    const collection = state.myads.items && state.myads.items[currentPage];
    const result = Array.isArray(collection) && collection
    || [];

    return result;
};

const getElements = state => {
    return state.items.elements;
};

export const getMetadata = (state, props) => {
    const url = getUrl(state, props);

    return state.items.collectionMetadata[url] || {};
};

export const getFilters = createSelector(
    getMetadata,
    itemsMetadata => {
        return itemsMetadata.filters || {};
    }
);

export const getUnfilteredTotal = createSelector(
    getMetadata,
    itemsMetadata => {
        return itemsMetadata.unfiltered_total;
    }
);

export const getTotal = createSelector(
    getMetadata,
    itemsMetadata => {
        return itemsMetadata.total;
    }
);

export const userAdsSelector = createSelector(
    getCollection,
    getElements,
    (collection, elements) => {
        return collection.map(id => elements[id]);
    }
);

export const isFetching = (state, props) => {
    const url = getUrl(state, props);

    return Boolean(state.items.isFetching[url]);
};

export const hasError = (state, props) => {
    const url = getUrl(state, props);

    return Boolean(state.items.isError[url]);
};

export const getActiveAdsCount = createSelector(
    getFilters,
    filters => {
        if (filters.status) {
            const { status } = filters;
            const activeAds = status.find(filter => filter.key === 'ACTIVE');

            return activeAds && activeAds.count;
        }
        return null;
    }
);
